import { Suspense, useEffect, useState } from 'react'
import { CatchBoundary } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { trpc } from '@/main'
import { AnimateNumber } from '@/components/custom/animate-number'

function Count(props: { className?: string }) {
  const { data } = useSuspenseQuery(trpc.common.getProfilesCount.queryOptions())

  // Mount at 0, then bump to the real count so the counter animates UP from zero. Starting at 0 also
  // keeps the server and first client render identical (both "0") — the real count arrives via an
  // effect, after hydration, so it can never mismatch.
  const [value, setValue] = useState(0)
  // react-doctor-disable-next-line react-hooks-js/set-state-in-effect -- deliberate: mount at 0 then bump post-hydration to animate up + keep SSR/first-client render identical (see above)
  useEffect(() => setValue(data.profilesCount), [data.profilesCount])

  return <AnimateNumber value={value} className={props.className} />
}

export function ProfilesCount(props: { className?: string }) {
  return (
    <CatchBoundary
      getResetKey={() => 'profiles-count'}
      errorComponent={() => <AnimateNumber value={0} className={props.className} />}
    >
      <Suspense fallback={<AnimateNumber value={0} className={props.className} />}>
        <Count className={props.className} />
      </Suspense>
    </CatchBoundary>
  )
}
